
<script>
  import { request } from './../../helpers/api'
  import { userStore, snackBarStore, tenantStore, peopleStore } from '../../state/store'
  import { isUserAdmin } from './../../helpers/utils'
  import TextInput from '../../components/TextInput.svelte'
  import { replace } from 'svelte-spa-router'
  import { t } from '../../i18n/i18n'
  
  export let person
  let editing = false

  let form = {
    email: person.email,
    name: '',
    phone: '',
    role: ''
  }

  const cancelEdit = () => {
    form.assignee = person.assignee
    form.name = person.name
    form.phone = person.phone
    form.role = person.role
    editing = false
  }

  const openEdit = () => {
    form.assignee = person.assignee
    form.name = person.name
    form.phone = person.phone
    form.role = person.role
    editing = true   
  }

  const submitForm = async () => {   
    try {
      // Submit form data
      const response = await request({
        url: `/api/users`,
        method: 'PUT',
        body: JSON.stringify({
          ...form
        })
      })

      // Update person in the store
      peopleStore.update((people) => {
        let updated = people.find(person => person._id === response._id)
        updated.role = response.role
        updated.name = response.name
        updated.phone = response.phone
        return [
          ...people
        ]
      })
      snackBarStore.set({ message: $t['User Updated'], type: 'success', selfDestruct: true  })
      cancelEdit()
    } catch (error) {
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }
  }

  const deleteUser = async () => {
    try {
      if($tenantStore.email === person.email) {
        throw new Error($t['You can not delete the main registered account'])
      }
      if(confirm($t.delete_person_message)) {
        const response = await request({
          url: `/api/users`,
          method: 'DELETE',
          body: JSON.stringify({
            email: person.email
          })
        })
        snackBarStore.set({ message: $t['User has been deleted'], type: 'success', selfDestruct: true  })
        replace('/people/')
      }
    } catch (error) {
      snackBarStore.set({ message: error.message, type: 'error' })
    }
  }


</script>

<style>
  select {
    width: 100%;
    margin-top: 1rem;
  }
</style>

<header>
  {#if !editing}
    <h1>{person.name}</h1>
    <div>
      <p>{$t.email}: {person.email}</p>
      <p>{$t.phone}: {person.phone}</p>
      <p>{$t.role}: {person.role}</p>
    </div>
  {:else}
  
  <form on:submit|preventDefault={submitForm}>

    <TextInput
    id='name'
    label='{$t.name}'
    validityMessage='{$t['Please enter a name']}'
    on:input={event => (form.name = event.target.value)}
    value="{person.name}" />
    <p>{$t.email}: {person.email}</p>
    <TextInput
    id='phone'
    label='{$t['phone']}'
    validityMessage='{$t['Please enter a phone number']}'
    on:input={event => (form.phone = event.target.value)}
    value="{person.phone}" />
      <label for="role">{$t.role}</label>
      <select 
        name="role" 
        id="role" 
        on:input={event => (form.role = event.target.value)}
        value="{person.role}" >
        <option value='admin'>{$t.admin}</option>
        <option value='worker'>{$t.worker}</option>
      </select>
    <div class="g-admin-buttons">
      <button on:click={cancelEdit} type="button">{$t.cancel}</button>
      <button class="update" type="submit">{$t.update}</button>
      <button class="delete" type="button" on:click={deleteUser}> {$t.delete} </button>
    </div>
  </form>

  {/if}
  {#if isUserAdmin($userStore)}
    {#if !editing}
      <div class="g-admin-buttons">
        <button on:click={openEdit} type='button' action='edit'>{$t.edit}</button>
      </div>
    {/if}
  {/if}
</header>
